import LogoNav from '../src/LogoNav';
export default LogoNav;
